import API from "utils/API";
import authHeader from "utils/auth-header";
import { ICreateChargeRequestParams } from "../domain/ICreateChargeRequestParams";
import { ICreateDischargeRequestParams } from "../domain/ICreateDischargeRequestParams";
import { ICreateRegistrationRequestParams } from "../domain/ICreateRegistrationRequestParams";
import { IGetResourcesListRequestParams } from "../domain/IGetResourcesListRequestParams";
import { IRegistration } from "../domain/IRegistration";
import { IResource } from "../domain/IResource";
import { IResourceTypes } from "../domain/IResourceTypes";
import { IGetResourcesListResponse } from "../domain/IGetResourcesListResponse";
import { ICreateServiceRequestParams } from "../domain/ICreateServiceRequestParams";
import { IRefuelResourceRequestParams } from "../domain/IRefuelResourceRequestParams";
import { IResourceListItem } from "../domain/IResourceListItem";
import { IResourceCategories } from "../domain/IResourceCategories";
import { IGetChargesResponse } from "../domain/IGetChargesResponse";
import { IUnit } from "Dashboard/domain/IUnit";
import { IResponseUnits } from "Dashboard/scenes/Stock/domain/IResponseUnits";
import { IGetChargesRequestParams } from "../domain/IGetChargesRequestParams";
import { ICategory } from "Dashboard/domain/ICategory";
import { IType } from "../../../domain/IType";
import { IGetRefuelsRequestParams } from "../domain/IGetRefuelsRequestParams";
import { IGetRefuelsResponse } from "../domain/IGetRefuelsResponse";
import { IGetResourcesDetailsResponse } from "../domain/IGetResourceDetailsResponse";
import { IGetConsumptionResponse } from "../domain/IConsumptionResponse";
import { IGetServicesResponse } from "../domain/IGetServicesResponse";
import { IInsepction } from "../domain/IInspection";
import { IGetInspectionsResponse } from "../domain/IGetInspectionsResponse";
import { ICreateInspectionRequestParams } from "../domain/ICreateInspectionRequestParams";
import { getQeuryParams } from "utils/queryParamsUtil";
import { IDeleteHistoricValueForResourceRequestParams } from "../domain/IDeleteHistoricValueForResourceRequestParams";
import { IAddHistoricValueToResourceRequestParams } from "../domain/IAddHistoricValueToResourceRequestParams";
import { IMessage } from "domain/IMessage";
import { IResourceStatusResponse } from "../domain/IResourceStatusResponse";
import { ICreateResource } from "../domain/ICreateResource";
import { IGetCensusResponse } from "../domain/IGetCensusResponse";
import { IUpdateResource } from "../domain/IUpdateResource";
import { ICreateChargeResponse } from "../domain/ICreateChargeResponse";
import { ICreateDischargeResponse } from "../domain/ICreateDischargeResponse";
import { IRefuelResourceResponse } from "../domain/IRefuelResourceResponse";
import { IUpdateCharge } from "../domain/IUpdateCharge";
import { IUpdateRefuel } from "../domain/IUpdateRefuel";
import { IRefuel } from "../domain/IRefuel";
import { IUpdateService } from "../domain/IUpdateService";
import { IService } from "../domain/IService";
import { IUpdateInspection } from "../domain/IUpdateInspection";
import { IResourceSimple } from "../domain/IResourceSimple";
import { IResponseResourcesSimple } from "../domain/IResponseResourcesSimple";
import { IGetReversesResponse } from "../domain/IGetReversesResponse";
import { ISubmitPendingReversRequestParams } from "../domain/ISubmitPendingReversRequestParams";
import { IRevers } from "../domain/IRevers";
import { IUpdateChargeResponse } from "../domain/IUpdateChargeResponse";
import { IDeleteRefuel } from "../domain/IDeleteRefuel";
import { IDeleteCharge } from "../domain/IDeleteCharge";
import { IDeleteServiceOrRepair } from "../domain/IDeleteServiceOrRepair";

const getResourcesList = async (
  search: IGetResourcesListRequestParams | undefined
): Promise<IResourceListItem[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetResourcesListResponse>(
      `/resources/public/resource${getQeuryParams(search)}`,
      { headers }
    );
    let resources = response.data.resources;
    return resources;
  } catch (err) {
    throw err;
  }
};

const getResourcesSimpleList = async (): Promise<IResourceSimple[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseResourcesSimple>(
      `/resources/public/resources-simple`,
      { headers }
    );
    let resources = response.data.resources;
    return resources;
  } catch (err) {
    throw err;
  }
};

const getResourceStatus = async (
  search: IGetResourcesListRequestParams | undefined
): Promise<IResourceStatusResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceStatusResponse>(
      `/resources/public/resource-status${getQeuryParams(search)}`,
      { headers }
    );
    let resources = response.data;
    return resources;
  } catch (err) {
    throw err;
  }
};

const getResourceDetails = async (
  resourceId: number
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetResourcesDetailsResponse>(
      `/resources/public/resource/${resourceId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getResourcePicture = async (resourceId: number): Promise<string> => {
  var headers = authHeader();
  try {
    const response = await API.get<any>(
      `/resources/public/resource/${resourceId}/picture`,
      { headers, responseType: "arraybuffer" }
    );
    let image = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );
    return response.headers["content-type"]
      ? `data:${response.headers["content-type"].toLowerCase()};base64,${image}`
      : "";
  } catch (err) {
    throw err;
  }
};

const uploadResourcePicture = async (
  image: any,
  resourceId: number
): Promise<IMessage> => {
  var headers = {
    "Content-Type": "multipart/form-data",
    ...authHeader(),
  };
  const data = new FormData();
  data.append("picture", image);
  try {
    const response = await API.post<IMessage>(
      `/resources/protected/resource/${resourceId}/picture`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateResource = async (
  data: IUpdateResource
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, ...rest } = data;
    const response = await API.put<IGetResourcesDetailsResponse>(
      `/resources/protected/resource/${resourceId}`,
      { ...rest },
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const addOrEditHistoricValueToResource = async (
  data: IAddHistoricValueToResourceRequestParams
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, ...rest } = data;
    const response = await API.put<IGetResourcesDetailsResponse>(
      `/resources/protected/resource/${resourceId}/value`,
      { ...rest },
      {
        headers,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteHistoricValueForResource = async (
  data: IDeleteHistoricValueForResourceRequestParams
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, year } = data;
    const response = await API.delete<IGetResourcesDetailsResponse>(
      `/resources/protected/resource/${resourceId}/value/${year}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createResource = async (data: ICreateResource): Promise<IResource> => {
  var headers = authHeader();
  try {
    const response = await API.post<IResource>(
      `/resources/protected/resource`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteResource = async (resourceId: number): Promise<any> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/resources/protected/resource/${resourceId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const createRegistration = async (
  resourceId: number,
  data: ICreateRegistrationRequestParams
): Promise<IRegistration> => {
  var headers = authHeader();
  try {
    const response = await API.post<IRegistration>(
      `/resources/protected/registration/${resourceId}`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createCharge = async (
  resourceId: number,
  data: ICreateChargeRequestParams
): Promise<ICreateChargeResponse> => {
  var headers = authHeader();
  try {
    const response = await API.post<ICreateChargeResponse>(
      `/resources/protected/resource/${resourceId}/charge`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCharges = async (
  params: IGetChargesRequestParams
): Promise<IGetChargesResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, ...rest } = params;
    const response = await API.get<IGetChargesResponse>(
      `/resources/public/resource/${resourceId}/charge${getQeuryParams(rest)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateCharge = async (
  data: IUpdateCharge
): Promise<IUpdateChargeResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, chargeId, ...rest } = data;
    const response = await API.put<IUpdateChargeResponse>(
      `/resources/protected/resource/${resourceId}/charge/${chargeId}`,
      { ...rest },
      { headers }
    );
    let charge = response.data;
    return charge;
  } catch (err) {
    throw err;
  }
};

const deleteCharge = async (data: IDeleteCharge): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/resources/protected/resource/${data.resourceId}/charge/${data.chargeId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createDischarge = async (
  chargeId: number,
  data: ICreateDischargeRequestParams
): Promise<ICreateDischargeResponse> => {
  var headers = authHeader();
  try {
    const response = await API.post<ICreateDischargeResponse>(
      `/resources/protected/discharge/${chargeId}`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getRefuels = async (
  params: IGetRefuelsRequestParams
): Promise<IGetRefuelsResponse> => {
  var headers = authHeader();
  try {
    const { resourceId, ...rest } = params;
    const response = await API.get<IGetRefuelsResponse>(
      `/resources/public/resource/${resourceId}/refuel${getQeuryParams(rest)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const refuelResource = async (
  resourceId: number,
  data: IRefuelResourceRequestParams
): Promise<IRefuelResourceResponse> => {
  var headers = authHeader();
  try {
    const response = await API.post<IRefuelResourceResponse>(
      `/resources/protected/resource/${resourceId}/refuel`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateRefuel = async (
  data: IUpdateRefuel
): Promise<IRefuel> => {
  var headers = authHeader();
  try {
    const { resourceId, refuelId, ...rest } = data;
    const response = await API.put<IRefuel>(
      `/resources/protected/resource/${resourceId}/refuel/${refuelId}`,
      { ...rest },
      { headers }
    );
    let refuel = response.data;
    return refuel;
  } catch (err) {
    throw err;
  }
};

const deleteRefuel = async (
  data: IDeleteRefuel
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IGetResourcesDetailsResponse>(
      `/resources/protected/resource/${data.resourceId}/refuel/${data.refuelId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getResourcesCategories = async (): Promise<ICategory[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceCategories>(
      "/resources/public/category",
      { headers }
    );
    let categories = response.data.categories;
    return categories;
  } catch (err) {
    throw err;
  }
};

const getResourcesTypes = async (): Promise<IType[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceTypes>("/resources/public/type", {
      headers,
    });
    let types = response.data.types;
    return types;
  } catch (err) {
    throw err;
  }
};

const getServices = async (
  resourceId: number
): Promise<IGetServicesResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetServicesResponse>(
      `/resources/public/resource/${resourceId}/service`,
      {
        headers,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateService = async (
  data: IUpdateService
): Promise<IService> => {
  var headers = authHeader();
  try {
    const { resourceId, serviceId, ...rest } = data;
    const response = await API.put<IService>(
      `/resources/protected/resource/${resourceId}/service/${serviceId}`,
      { ...rest },
      { headers }
    );
    let refuel = response.data;
    return refuel;
  } catch (err) {
    throw err;
  }
};

const deleteServiceOrRepair = async (
  data: IDeleteServiceOrRepair
): Promise<IGetResourcesDetailsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IGetResourcesDetailsResponse>(
      `/resources/protected/resource/${data.resourceId}/service/${data.maintenanceId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createServiceForResource = async (
  resourceId: number,
  data: ICreateServiceRequestParams
): Promise<IResource> => {
  var headers = authHeader();
  try {
    const response = await API.post<IResource>(
      `/resources/public/resource/${resourceId}/service`,
      data,
      { headers }
    );
    let resource = response.data;
    return resource;
  } catch (err) {
    throw err;
  }
};

const getResourceUsageUnits = async (): Promise<IUnit[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResponseUnits>("/common/public/unit", {
      headers,
    });
    return response.data.units;
  } catch (err) {
    throw err;
  }
};

const getConsumption = async (
  resourceId: number
): Promise<IGetConsumptionResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetConsumptionResponse>(
      `/resources/public/resource/${resourceId}/consumption`,
      {
        headers,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getInspections = async (resourceId: number): Promise<IInsepction[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetInspectionsResponse>(
      `/resources/public/resource/${resourceId}/inspection`,
      {
        headers,
      }
    );
    return response.data.inspections;
  } catch (err) {
    throw err;
  }
};

const createInspection = async (
  resourceId: number,
  data: ICreateInspectionRequestParams
): Promise<IInsepction> => {
  var headers = authHeader();
  try {
    const response = await API.post<IInsepction>(
      `/resources/protected/resource/${resourceId}/inspection`,
      data,
      { headers }
    );
    let inspection = response.data;
    return inspection;
  } catch (err) {
    throw err;
  }
};

const updateInspection = async (
  data: IUpdateInspection
): Promise<IInsepction> => {
  var headers = authHeader();
  try {
    const { resourceId, inspectionId, ...rest } = data;
    const response = await API.put<IInsepction>(
      `/resources/protected/resource/${resourceId}/inspection/${inspectionId}`,
      { ...rest },
      { headers }
    );
    let refuel = response.data;
    return refuel;
  } catch (err) {
    throw err;
  }
};

const getResourcesCensus = async (): Promise<IGetCensusResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetCensusResponse>(
      `/resources/public/resource/census`,
      {
        headers,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getReversesList = async (): Promise<IGetReversesResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetReversesResponse>(
      "/resources/public/revers",
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const submitPendingRevers = async (
  data: ISubmitPendingReversRequestParams
): Promise<IRevers> => {
  var headers = authHeader();
  try {
    const response = await API.post<IRevers>(
      "resources/public/revers-pending",
      data,
      { headers }
    );
    let confirmedRevers = response.data;
    return confirmedRevers;
  } catch (err) {
    throw err;
  }
};

const getSubmittedReversForPrint = async (
  reversId: number
): Promise<IRevers> => {
  try {
    var headers = authHeader();
    const response = await API.get<IRevers>(
      `resources/public/revers/${reversId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteReversPendingCharge = async (chargeId: number): Promise<IMessage> => {
  try {
    var headers = authHeader();
    const response = await API.delete<IMessage>(
      `resources/public/revers/${chargeId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export const resourcesServices = {
  getResourcesList,
  getResourcesSimpleList,
  getResourceDetails,
  getResourcePicture,
  uploadResourcePicture,
  addOrEditHistoricValueToResource,
  deleteHistoricValueForResource,
  createResource,
  deleteResource,
  getCharges,
  createCharge,
  updateCharge,
  deleteCharge,
  createDischarge,
  getRefuels,
  getServices,
  updateService,
  deleteServiceOrRepair,
  refuelResource,
  updateRefuel,
  deleteRefuel,
  createRegistration,
  createServiceForResource,
  getResourcesCategories,
  getResourcesTypes,
  getResourceUsageUnits,
  getConsumption,
  getInspections,
  createInspection,
  updateInspection,
  getResourceStatus,
  updateResource,
  getResourcesCensus,
  getReversesList,
  submitPendingRevers,
  getSubmittedReversForPrint,
  deleteReversPendingCharge,
};
